var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dropdown" },
    [
      _c("span", {
        staticClass: "btn dropdown-toggle",
        attrs: { role: "button" },
        on: {
          click: function($event) {
            if ($event.target !== $event.currentTarget) {
              return null
            }
            $event.stopPropagation()
            return _vm.toggleDropdown($event)
          }
        }
      }),
      _vm._v(" "),
      _vm.showDropdown
        ? _c(
            "div",
            { staticClass: "dropdown-menu dropdown-menu-right" },
            [
              _vm.isSquareBrick
                ? [
                    _vm.displayInfo
                      ? _c(
                          "a",
                          {
                            staticClass: "dropdown-item",
                            class: [_vm.canClickInfo ? "" : "disabled"],
                            attrs: { href: "#" },
                            on: { click: _vm.infoClick }
                          },
                          [
                            _c("i", { staticClass: "fas fa-info-circle" }),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.resource(
                                    "JourneyBuilder_JourneyBrickMenu_Info_DisplayName"
                                  )
                                ) +
                                "\n            "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.displayNavigateToActionableReportLink
                      ? _c("navigate-to-actionable-report-link", {
                          staticClass: "dropdown-item",
                          attrs: {
                            "journey-id": _vm.currentJourneyId,
                            "highlighted-brick-id": _vm.brickId,
                            disabled: !_vm.canNavigateToActionableReport
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "dropdown-item",
                        class: [_vm.canClickAddConnection ? "" : "disabled"],
                        attrs: { href: "#" },
                        on: { click: _vm.addConnectionClick }
                      },
                      [
                        _c("i", { staticClass: "fas fa-bullseye" }),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.resource(
                                "JourneyBuilder_JourneyBrickMenu_AddRoute_DisplayName"
                              )
                            ) +
                            "\n            "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "dropdown-item",
                        class: [_vm.canClickSettings ? "" : "disabled"],
                        attrs: { href: "#" },
                        on: { click: _vm.settingsClick }
                      },
                      [
                        _c("i", { staticClass: "fas fa-cog" }),
                        _vm._v(
                          _vm._s(
                            _vm.resource(
                              "JourneyBuilder_JourneyBrickMenu_Settings_DisplayName"
                            )
                          ) + "\n            "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "dropdown-item",
                        class: [_vm.canClickDelete ? "" : "disabled"],
                        attrs: { href: "#" },
                        on: { click: _vm.deleteClick }
                      },
                      [
                        _c("i", { staticClass: "fas fa-trash" }),
                        _vm._v(
                          _vm._s(
                            _vm.resource(
                              "JourneyBuilder_JourneyBrickMenu_Remove_DisplayName"
                            )
                          ) + "\n            "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm.isJourneyBrick
                      ? [
                          _c(
                            "a",
                            {
                              staticClass: "dropdown-item",
                              class: [_vm.journeyUrl ? "" : "disabled"],
                              attrs: { href: _vm.journeyUrl || "#" },
                              on: {
                                click: function($event) {
                                  _vm.showDropdown = false
                                }
                              }
                            },
                            [
                              _c("i", { staticClass: "fas fa-route" }),
                              _vm._v(
                                _vm._s(
                                  _vm.resource(
                                    "JourneyBuilder_JourneyBrickMenu_NavigateToJourney_DisplayName"
                                  )
                                ) + "\n                "
                              )
                            ]
                          )
                        ]
                      : _vm._e()
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.supportsComments
                ? [
                    _c(
                      "a",
                      {
                        staticClass: "dropdown-item",
                        class: {
                          open: _vm.showDropdown && _vm.showCommentSection,
                          disabled: !_vm.hasComments
                        },
                        attrs: { href: "#" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            $event.stopPropagation()
                            return _vm.toggleCommentSection($event)
                          }
                        }
                      },
                      [
                        _vm._m(0),
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.resource(
                                "JourneyBuilder_JourneyBrickMenu_Comments_DisplayName"
                              )
                            ) +
                            "\n                \n                "
                        ),
                        _vm.hasUnseenComments
                          ? _c("has-unseen-comments-marker", {
                              staticClass: "has-unseen-comments-marker"
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                : _vm._e()
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showDropdown && _vm.showCommentSection
        ? _c("comments-section", {
            staticClass: "menu-comments-section",
            attrs: { "related-id": _vm.brickId, type: "Brick" },
            nativeOn: {
              click: function($event) {
                $event.stopPropagation()
              },
              wheel: function($event) {
                $event.stopPropagation()
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "fa-stack" }, [
      _c("i", { staticClass: "far fa-comment-alt fa-stack-2x" }),
      _vm._v(" "),
      _c("i", { staticClass: "fas fa-align-left fa-stack-1x" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }